const expeditedPlusLanguages = [
  "albanian",
  "catalan",
  "creole",
  "croatian",
  "czech",
  "danish",
  "dutch",
  "english",
  "french",
  "frenchCan",
  "german",
  "hungarian",
  "italian",
  "polish",
  "portugueseBrazil",
  "portuguesePortugal",
  "romanian",
  "slovak",
  "slovenian",
  "spanish",
  "swedish",
  "turkish",
];

export { expeditedPlusLanguages };
